import type { ComponentCommonMedia } from '@edwin-group/people-graphql';
import { useResponsiveImage } from '@/utils/useResponsiveImage';
import classNames from 'classnames';

export default function DefaultContentTemplateMedia({
  component,
  className,
  isDefaultContentTemplate = false,
}: {
  component: ComponentCommonMedia;
  className?: string;
  isDefaultContentTemplate?: boolean;
}) {
  const { src, alt } = useResponsiveImage(component!.media);

  return (
    <div
      className={classNames(className, {
        'my-0': isDefaultContentTemplate,
        'my-sh-60': !isDefaultContentTemplate,
      })}
      key={component.id}>
      <div style={{ paddingTop: '56.25%', position: 'relative' }}>
        {src ? (
          <img
            alt={alt ?? 'Media common component'}
            src={src}
            style={{ position: 'absolute', zIndex: 5, top: 0, left: 0, width: '100%', height: '100%' }}
            className=" h-auto w-full rounded-2xl object-cover"
          />
        ) : (
          <div
            style={{ position: 'absolute', zIndex: 5, top: 0, left: 0, width: '100%', height: '100%' }}
            className=" animate-pulse rounded-2xl bg-people-gray-200"
            aria-hidden
          />
        )}
      </div>
    </div>
  );
}
